const parseHostList = (rawHosts) =>
  (rawHosts || "")
    .split(",")
    .map((host) => host.trim().toLowerCase())
    .filter(Boolean);

/**
 * GraphQL endpoint for the current front-end host.
 *
 * Hosts listed in REACT_APP_PROXIED_API_HOSTS reverse-proxy `/graphql` and
 * `/api/*` to the API (see vercel.json). Their registrable domain differs from
 * the API's, so a session cookie set by the API domain would be a third-party
 * cookie that browsers drop; addressing the API through the front-end origin
 * keeps the httpOnly cookie first-party. Resolved at runtime because a single
 * build serves several domains, and only these hosts must switch.
 */
export const resolveGraphqlHttpUrl = (
  envGraphqlUrl,
  proxiedHosts,
  hostname,
) => {
  const currentHost = (hostname || "").toLowerCase();
  if (currentHost && parseHostList(proxiedHosts).indexOf(currentHost) >= 0) {
    return "/graphql";
  }
  return envGraphqlUrl || "";
};

export const GRAPHQL_HTTP_URL = resolveGraphqlHttpUrl(
  process.env.REACT_APP_REST_BFF_URL,
  process.env.REACT_APP_PROXIED_API_HOSTS,
  typeof window !== "undefined" ? window.location.hostname : "",
);

export const API_ORIGIN = GRAPHQL_HTTP_URL.replace(/\/graphql\/?$/, "");
